import api from './api'

export type CeleryTaskState = 'PENDING' | 'STARTED' | 'SUCCESS' | 'FAILURE' | 'RETRY' | string

export type TaskStatusResponse = {
  task_id: string
  state: CeleryTaskState
  result?: unknown
  error?: string
}

const tasksApi = {
  /**
   * Consulta o status de uma Celery task pelo task_id.
   */
  getStatus: async (taskId: string): Promise<TaskStatusResponse> => {
    const response = await api.get(`/api/v1/tasks/${taskId}`)
    return response.data
  },
}

export default tasksApi
